import React from 'react'
import { useIntl } from 'react-intl'
import Modal from 'LuxKit/Modal/Modal'
import FlexibleCancellationPolicyModalWithoutDates from './FlexibleCancellationPolicyModalWithoutDates'
import FlexibleCancellationPolicyModalWithDates from './FlexibleCancellationPolicyModalWithDates'

export interface Props {
  today: moment.Moment
  checkInDate?: string | moment.Moment
  startBasedOnToday: moment.Moment
  startBasedOnCheckIn: moment.Moment | undefined
  cancellationAfterChangeOfMindPeriod: boolean
  days: number
  /** Whether this is a charter bundle (flights + hotel). Affects terminology and shows charter-specific fees. */
  isCharter?: boolean
}

function OfferPropertyFlexibleCancellationPolicyTimelineModal(props: Props) {
  const {
    today,
    checkInDate,
    startBasedOnToday,
    startBasedOnCheckIn,
    cancellationAfterChangeOfMindPeriod,
    days,
    isCharter,
  } = props

  const intl = useIntl()
  const hasDates = !!checkInDate && !!startBasedOnCheckIn

  return (
    <Modal
      title={intl.formatMessage({
        id: 'UUX1Q66CrL',
        defaultMessage: 'Cancellation policy',
        description: 'Title for flexible cancellation policy modal',
      })}
    >
      <div>
        {hasDates && checkInDate && startBasedOnCheckIn && (
          <FlexibleCancellationPolicyModalWithDates
            today={today}
            checkInDate={checkInDate}
            startBasedOnToday={startBasedOnToday}
            startBasedOnCheckIn={startBasedOnCheckIn}
            cancellationAfterChangeOfMindPeriod={cancellationAfterChangeOfMindPeriod}
            isCharter={isCharter}
          />
        )}
        {!hasDates && (
          <FlexibleCancellationPolicyModalWithoutDates
            days={days}
            isCharter={isCharter}
          />
        )}
      </div>
    </Modal>
  )
}

export default OfferPropertyFlexibleCancellationPolicyTimelineModal
